const tooltipFormActions = {
  edit: 'editar',
  delete: 'deletar',
  equipment: 'Ir para os detalhes do equipamento',
  service: 'Ir para os detalhes do serviço'
};

export default tooltipFormActions;
